import CustomRangePicker from './CustomRangePicker';

export default CustomRangePicker;
